import { getAspectRatioRate } from '@zappyrent/hundop';
import { cover, rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  position: relative;
`;

export const StyledTextOuterWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
`;

export const StyledTextInnerWrapper = styled.div`
  width: 60%;
  padding-right: ${rem('24px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-top: ${rem('40px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    width: 50%;
  }
`;

export const StyledImageOuterWrapper = styled.div`
  width: 40%;
  margin-left: 60%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    width: 50%;
    margin-left: 50%;
  }
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: ${getAspectRatioRate(376, 240)};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('16px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-top: ${getAspectRatioRate(707, 707)};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    padding-top: ${getAspectRatioRate(707, 497)};
  }
`;

export const StyledImage = styled.img`
  ${cover()}
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const StyledHeadingWrapper = styled.div`
  margin-bottom: ${rem('-24px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('-32px')};
  }
`;

export const StyledParagraph = styled.p`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('16px')};
  line-height: 140%;
  margin: 0;
`;
